import { ApiLocalStorage } from '../../../utils/ApiLocalStorage';
import { SCHEMA_STORAGE_KEY } from '../services/SchemaService';

export const getDynamicSteps = (currentPageName: string) => {
  const schema = ApiLocalStorage.get(SCHEMA_STORAGE_KEY);
  
  if (!schema) return {totalSteps: 0, currentStep: 0};
  
  const steps: string[] = [];
  
  steps.push('personal');
  steps.push('contact');
  
  if (schema.address && schema.address.formFields && schema.address.formFields.length > 0) {
    steps.push('address');
  }
  
  if (schema.additionalInfo && schema.additionalInfo.formFields && schema.additionalInfo.formFields.length > 0) {
    steps.push('additionalInfo');
  }
  
  if (schema.authenticationType === 'Password') {
    steps.push('createPassword');
  }
  
  // Adiciona o passo complementar se existir no schema
  if (schema.complementaryStepAfterOnboarding && schema.complementaryStepAfterOnboarding.formFields && schema.complementaryStepAfterOnboarding.formFields.length > 0) {
    steps.push('complementaryStep');
  }
  
  const totalSteps = steps.length;
  const currentStepIndex = steps.findIndex(step => step === currentPageName);
  const currentStep = currentStepIndex >= 0 ? currentStepIndex + 1 : 1;
  
  return {totalSteps, currentStep};
};
